import React from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import arrow from "../../Images/arrow.svg";
import { setStreaming } from "../../slice/loaderSlice";
import { selectMessages, updateMessage } from "../../slice/MessageSlice";
import { selectTheme } from "../../slice/SettingSlice";
import {
	closeVariantValidator,
	resetVariantValidator,
	selectVariant,
	selectVariantValidatorShow,
	selectVariantValidatorVariants,
} from "../../slice/VariantValidatorSlice";
import "./variantValidatorModal.css";
import { createSelectedVariantLabel } from "../../utils/variantSelection";
export default function VariantValidatorModal() {
	const theme = useSelector(selectTheme);
	const dispatch = useDispatch();
	const show = useSelector(selectVariantValidatorShow);
	const variants = useSelector(selectVariantValidatorVariants);
	const messages = useSelector(selectMessages);
	const selectVar = (variant) => {
		dispatch(selectVariant(variant));
	};
	function handleClose() {
		if (messages.length > 0) {
			dispatch(
				updateMessage({
					i: messages.length - 1,
					obj: {
						text: "",
						stopText: "Variant selection has been interrupted by the user.",
						pending: null,
					},
				}),
			);
		}
		dispatch(setStreaming(false));
		dispatch(closeVariantValidator());
		dispatch(resetVariantValidator());
	}

	return (
		<>
			<Modal
				show={show}
				onHide={handleClose}
				backdrop="static"
				className={"modal " + theme}
				centered={isMobile}
			>
				<Modal.Header>
					<Modal.Title className="title">Multiple variants found</Modal.Title>
					<Button onClick={handleClose} id="close" className="close-button">
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg"
							id="close-icon"
						>
							<g fill="none" fillRule="evenodd">
								<path
									fill="#344D66"
									fillRule="nonzero"
									d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
								/>
							</g>
						</svg>
					</Button>
				</Modal.Header>
				<Modal.Body className="variant-validator-body">
					<p className="variant-validator-description">
						{"We found multiple variants for this search. Choose the one you want to expand on:"}
					</p>
					<ul className="variant-validator-list">
						{variants.map((variant) => {

							return (
								<li
									key={variant.selectedIndex}
									className="variant-validator-list-item"
								>
									<button
										type="button"
										className="variant-validator-option"
										onClick={() => selectVar(variant)}
										title={createSelectedVariantLabel(variant, "-")}
									>
										<span>{createSelectedVariantLabel(variant)}</span>
										<img
											src={arrow}
											alt=""
											aria-hidden="true"
											className="variant-validator-arrow"
										/>
									</button>
								</li>
							);
						})}
					</ul>
				</Modal.Body>
			</Modal>
		</>
	);
}
